import Menu from "./components/Menu/";
import "./assets/index.scss";
import Profile from "./components/Profile";
import Skills from "./components/Skills";
import Biography from "./components/Biography";
import Experience from "./components/Experience";
import { Fragment } from "react";
import 'fontsource-roboto';
import { BrowserRouter as Router, Route } from "react-router-dom";



function App() {
  return (
    <Fragment>
      <Router>
        <Menu />
        <Profile />
        <Route>
          <h1 className="title-text">Biography</h1>
          <Biography />
        </Route>
        <Route>
          <h1 className="title-text">Skills</h1>
          <Skills />
        </Route>
        <h1 className="title-text">Experience</h1>
        <Experience />
      </Router>
    </Fragment>
  );
}

export default App;
